import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export function orgSettingsQueryOptions(orgId: string) {
  return queryOptions({
    queryKey: ['org-settings', orgId] as const,
    staleTime: 30 * 60 * 1000,
    queryFn: async () => {
      const res = await api.api.org[':orgId'].settings.$get({ param: { orgId } });
      if (!res.ok) throw new Error(i18n.t('errors.unexpected'));
      return res.json();
    }
  });
}
